import styled, { css } from 'styled-components'

const Wrapper = styled.div`
  ${({ theme }) => css`
    padding: ${theme.spacing(5)};
    color: ${theme.palette.white};

    ${theme.media('sm')} {
      padding: ${theme.spacing(5)} ${theme.spacing(10)};
    }
  `}
`

const BannerContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  background: rgb(228, 228, 228);
  background: linear-gradient(0deg, rgba(228, 228, 228, 1) 26%, rgba(243, 243, 243, 1) 31%);
  padding: 20px;
  min-height: 210px;
  overflow: hidden;
  position: relative;
`

const Content = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: ${theme.spacing(0)} ${theme.spacing(6)};
    ${theme.media('sm')} {
      padding: ${theme.spacing(0)} ${theme.spacing(2)};
    }

    h1 {
      font-size: 3rem;
    }
  `}
`

const TextContainer = styled.h1`
  font-size: 18px;
  text-align: center;
`
const HeroIcon = styled.div`
  ${() => css`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 8rem;
    height: 8rem;
    border-radius: 4rem;
    background-color: #89b641;

    > svg {
      color: white;
    }
  `}
`
const LeftImage = styled.img`
  ${({ theme }) => css`
    height: 200px;
    position: absolute;
    left: -82px;
    ${theme.media('sm')} {
      position: relative;
      left: 0;
    }
  `}
`

const RightImage = styled.img`
  ${({ theme }) => css`
    height: 200px;
    position: absolute;
    right: -82px;
    ${theme.media('sm')} {
      position: relative;
      right: 0;
    }
  `}
`

export default {
  Wrapper,
  BannerContainer,
  HeroIcon,
  TextContainer,
  LeftImage,
  RightImage,

  Content,
}
